__turbopack_context__.v({
  "disabled": "LandDocumentUploader-module-scss-module__VNlDUq__disabled",
  "document": "LandDocumentUploader-module-scss-module__VNlDUq__document",
  "documentButtons": "LandDocumentUploader-module-scss-module__VNlDUq__documentButtons",
  "documentButtons__delete": "LandDocumentUploader-module-scss-module__VNlDUq__documentButtons__delete",
  "documentButtons__download": "LandDocumentUploader-module-scss-module__VNlDUq__documentButtons__download",
  "documentsList": "LandDocumentUploader-module-scss-module__VNlDUq__documentsList",
  "isSaved": "LandDocumentUploader-module-scss-module__VNlDUq__isSaved",
  "label": "LandDocumentUploader-module-scss-module__VNlDUq__label",
  "land-documents-description": "LandDocumentUploader-module-scss-module__VNlDUq__land-documents-description",
  "land-download": "LandDocumentUploader-module-scss-module__VNlDUq__land-download",
  "wrapper": "LandDocumentUploader-module-scss-module__VNlDUq__wrapper",
});
